import React, { useState } from "react";
import { 
    Flex, 
    Table, 
    TableContainer, 
    Tbody, 
    Td, 
    Th, 
    Thead, 
    Tr,
    Button, 
    Tooltip,
    Text,
    Spinner,
    Link
} from "@chakra-ui/react";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-hot-toast";

// import api from '../../api';
// import { getUsers } from "../../actions/userActions"

const AdminProductsTable = ({
    products,
    loading,
    error,
    currentPage,
    totalPages,
    page,
    setPage,
    toggleProductActive,
}) => {
    const [operationLoading, setOperationLoading] = useState(false);
    // const dispatch = useDispatch();

    // const deleteUserRequest = async (id) => {
    //     setOperationLoading(true);
    //     try{
    //         const response = await api.delete(`/users/${id}`);
    //         console.log(response);
    //         dispatch(getUsers({page: 1, limit: 10}));
    //         setOperationLoading(false);
    //         toast.success("Usuario eliminado con éxito.");
    //     }catch(error){
    //         console.log(error);
    //         setOperationLoading(false);
    //         toast.error("Algo salió mal, inténtalo más tarde.");
    //     }
    // }

    const formatDate = (date) => {
        const newDate = new Date(date);
        const day = newDate.getDate();
        const month = newDate.getMonth() + 1;
        const year = newDate.getFullYear();
        return `${day}/${month}/${year}`;
    }

    if(loading) return (
        <Flex
            mt='20px'
            w="100%"
            h="100%"
            justifyContent="center"
            alignItems="center"
            flexDir='column'
        >   
            <Spinner />
        </Flex>
    )

    if(error) return (
        <Flex
            mt='20px'
            w="100%"
            h="100%"
            justifyContent="center"
            alignItems="center"
            flexDir='column'
        >   
            <Text>Algo salió mal, inténtalo más tarde.</Text>
        </Flex>
    )

    if(products.length === 0) return (
        <Flex
            mt='20px'
            w="100%"
            h="100%"
            justifyContent="center"
            alignItems="center"
            flexDir='column'
        >
            <Text>No hay productos.</Text>
        </Flex>
    )


    return (
    <Flex
        w="100%"
        flexDir='column'
        alignItems='end'
    >
        <TableContainer
            w="100%"
            maxW="100%"
            h="100%"
            maxH="100%"
            overflow="auto"
        >
            <Table 
                size="sm"
                variant="striped"
                colorScheme='facebook'
            >
                <Thead>
                    <Tr>
                        <Th>Nombre</Th>
                        <Th>Descripción</Th>
                        <Th>Creador</Th>
                        <Th>Creación</Th>
                        <Th>Stores</Th>
                        <Th>Acciones</Th>
                    </Tr>
                </Thead>
                <Tbody>
                {products.map((product) => (
                    <Tr key={product._id}>
                        <Td>{product.name}</Td>
                        <Td>{product.description}</Td>
                        <Td>{product.user.name}</Td>
                        <Td>{formatDate(product.createdAt)}</Td>
                        <Td>
                            <Flex
                                justifyContent='flex-start'
                                alignItems='center'
                                flexDir='column'
                                flexWrap='wrap'
                                maxW={'200px'}
                            >
                                {product.stores.map((store) => (
                                    <Link
                                        key={store._id}
                                        href={`/${store.shortName}`}
                                        target='_blank'
                                    >
                                        {store.name}
                                    </Link>
                                ))}
                            </Flex>
                        </Td>
                        <Td>
                            <Flex
                                justifyContent='flex-start'
                                alignItems='center'
                            >
                                <Tooltip 
                                    label={product.active ? 'Desactivar' : 'Activar'}
                                    aria-label={product.active ? 'Desactivar' : 'Activar'}
                                >
                                    <Button
                                        size='sm'
                                        colorScheme='blue'
                                        variant='outline'
                                        borderRadius='50%'
                                        p='5px'
                                        isLoading={operationLoading}
                                        onClick={() => toggleProductActive(product._id, setOperationLoading)}
                                    >
                                        {
                                            product.active ?
                                            <IoEyeOff/>
                                            :
                                            <IoEye />
                                        }
                                    </Button>
                                </Tooltip>
                            </Flex>
                        </Td>
                    </Tr>
                ))}
                </Tbody>
            </Table>
            <Flex
                w='100%'
                justifyContent='space-between'
                alignItems='baseline'
            >
                <Flex
                    mt='20px'
                    justifyContent='start'
                    alignItems='baseline'
                >
                    <Button
                        fontSize={'.9rem'}
                        mr='5px'
                        size='xs'
                        colorScheme='blue'
                        variant='outline'
                        disabled={currentPage === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        <MdChevronLeft />
                    </Button>
                    <Button
                        fontSize={'.9rem'}
                        mr='10px'
                        size='xs'
                        colorScheme='blue'
                        variant='outline'
                        disabled={currentPage === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        <MdChevronRight />
                    </Button>
                    <Text
                        mt='20px'
                        fontSize='.9rem'
                    >
                        Pág. {currentPage} de {totalPages}
                    </Text>
                </Flex>
            </Flex>
        </TableContainer>
    </Flex>
    );
}

export default AdminProductsTable;